/**
* Horizontal Scroller JS
* -----------------------------------------------------------------------------
*
* All the JS for the Horizontal Scroller component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
// import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'horizontal-scroller',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.horizontal-scroller__inner' ).each( function( key, val ) {
        let navHeight = $( '.navbar' ).outerHeight();

        if ( $( '#wpadminbar' ).length ) {
          navHeight += $( '#wpadminbar' ).outerHeight();
        }

        const panels = $( val ).find( '.horizontal-scroller__panels' );
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: val,
            pin: val,
            start: 'top ' + navHeight,
            end: '+=' + ( $( val ).find( '.horizontal-scroller__panel' ).height() * $( val ).find( '.horizontal-scroller__panel' ).length ),
            scrub: true,
          },
        } );
        tl.to( panels, {x: -panels[0].scrollWidth + panels[0].clientWidth, ease: 'none'}, 0 );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'horizontal-scroller', COMPONENT );
} )( app );
